import { BranchMonthlyDeliveryPipeline } from './dashboard/widget/branch-monthly-delivery-pipeline';
import { BranchMonthlyRevenue } from './dashboard/widget/branch-monthly-revenue';
import { BranchMonthlyRevenuePipeLine } from './dashboard/widget/branch-monthly-revenue-pipeline';
import { ConversationView } from './conversation/wm-conversation-view';
import { DashboardFilter } from './dashboard/widget/dashboard-filter';
import { GeneratedPurchaseOrdersWidget } from './dashboard/widget/generated-purchase-orders-widget';
import { GeneratedQuotesWidget } from './dashboard/widget/issued-quotes-widget';
import { SalesSuccessWidget } from './dashboard/widget/sales-success-widget';
import { WebModuleBranchQuoteConversationEditor } from './conversation/wm-branchquote-support-editor';
import { WebModuleBranchQuoteSupportNew } from './conversation/wm-branchquote-support-new';
import { WebModuleConversationEntryView, WebModuleConversationUsersView } from './conversation/wm-conversation-entry';
import { WebModuleConversationEntryDropZone } from './conversation/wm-conversation-entry-dropzone';
import { WebModuleFranchiseeBranchEditor } from '../franchisee/editors/franchisee-branch-editor';
import { WebModuleFranchiseeBranchesEditor } from '../franchisee/editors/franchisee-branches-editor';

import { WebModuleQuoteSupportInboxView } from './conversation/wm-branchquote-support';

export const franchiseeComponentRegistry = {
  branchEditor: WebModuleFranchiseeBranchEditor,
  branchesEditor: WebModuleFranchiseeBranchesEditor,
  conversationView: ConversationView,
  supportInboxView: WebModuleQuoteSupportInboxView,
  conversationEntryView: WebModuleConversationEntryView,

  conversationUsers: WebModuleConversationUsersView,
  newSupportView: WebModuleBranchQuoteSupportNew,
  conversationEntryDropZone: WebModuleConversationEntryDropZone,

  webModuleBranchQuoteConversationEditor: WebModuleBranchQuoteConversationEditor,
  dashboardFilterControls: DashboardFilter,
  dashboardBranchMonthlyDeliveryPipeline: BranchMonthlyDeliveryPipeline,
  dashboardBranchMonthlyRevenue: BranchMonthlyRevenue,
  dashboardBranchMonthlyRevenuePipeLine: BranchMonthlyRevenuePipeLine,
  dashboardSalesSuccessWidget: SalesSuccessWidget,
  dashboardGeneratedPurchaseOrderWidgets: GeneratedPurchaseOrdersWidget,
  dashboardGeneratedQuotesWidget: GeneratedQuotesWidget
};
